import { gql } from "../../../../../gql/__generated__/gql";

export const SEND_MESSAGE = gql(`
  mutation sendMessage($content: String!, $sendMessageCollabId: String!) {
    sendMessage(content: $content, collabId: $sendMessageCollabId)
  }
`);
